<template>
  <div class="product-box">
    <banner-box />
    <div class="content">
      <div class="selects">
        <p class="title">Product</p>
        <div class="items">
          <p
            v-for="(item, index) in btnData"
            class="item"
            :class="{active: curSelect === item.id}"
            :key="index"
            @click="handleSelect(item.id)"
          >{{item.name}}</p>
        </div>
      </div>
      <p class="line"></p>
      <div class="rows">
        <div
          v-for="(item, index) in curData"
          class="row"
          :key="index"
        >
          <p class="url-box">
            <img class="img" v-if="item.url" :src="item.url" alt="img">
          </p>
          <p class="title" :alt="item.title">{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sp } from '../../api/home'

export default {
  name: 'index',
  data () {
    return {
      curSelect: 0,
      btnData: [
        // {
        //   name: '家具',
        //   data: [
        //     { title: 'ケヤキ', url: '' }
        //   ]
        // },
        // {
        //   name: '構造材',
        //   data: [
        //     { title: 'セン', url: '' }
        //   ]
        // }
      ]
    }
  },
  computed: {
    curData () {
      let data = []
      try {
        this.btnData.forEach((v, i) => {
          if (v.id === this.curSelect) {
            data = this.btnData[i].data
          }
        })
      } catch (e) {
        console.log('curData==>', e)
      }
      return data
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { id } = this.$route.query
      if (id) this.curSelect = id
      this.getProductData()
    },
    async getProductData () {
      const { data } = await sp()
      console.log('getProductData==>', data)
      const { id } = this.$route.query
      this.btnData = data.map((v, i) => {
        if (i === 0 && !id) this.curSelect = v.id
        return {
          id: v.id,
          name: v.name,
          data: v.sp.map(q => {
            return {
              title: q.name,
              url: q.coverPath
            }
          })
        }
      })
    },
    handleSelect (id) {
      this.curSelect = id
    }
  }
}
</script>

<style lang="less" scoped>
  .product-box{
    display: flex;
    flex-direction: column;

    .desc{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
      line-height: 34px;
      margin-top: 58px;
      margin-left: 279px;
    }

    .btns{
      margin-top: 53px;
      margin-left: 259px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0px 48px;
        height: 81px;
        background: #E6F0F7;
        border-radius: 40px;
        text-align: center;
        margin-right: 46px;
        cursor: pointer;
        transition: all .2s linear;

        &.active{
          background: #374475;

          .name{
            color: #f6f6f6;
          }
        }

        .name{

          font-weight: 400;
          font-size: 30px;
          color: #374475;
          line-height: 81px;
        }

        .img{
          flex-shrink: 0;
          width: 27px;
          height: 27px;
          background: #E6F0F7;
          border-radius: 50%;
          border: 2px solid #374475;
          display: inline-block;
          line-height: 27px;
          font-size: 12px;
          font-weight: bold;
          margin-left: 18px;
        }
      }
    }

    .content{
      margin-top: 68px;
      margin-left: 259px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      position: relative;

      .selects{
        display: flex;
        flex-direction: column;
        padding-bottom: 122px;
        width: 371px;
        flex-shrink: 0;

        .title{
          font-weight: 400;
          font-size: 24px;
          color: #374475;
          margin-left: 31px;
          margin-top: 28px;
          margin-bottom: 24px;
        }

        .items {
          margin-top: 32px;

          .item {
            height: 23px;
            font-family: 04 KanjyukuGothic;
            font-weight: 400;
            font-size: 24px;
            color: #cccccc;

            padding-left: 31px;
            margin-bottom: 27px;

            position: relative;
            cursor: pointer;

            &.active{
              color: #374475;

              &:before{
                background: #374475;
              }
            }

            &:before{
              content: '';
              position: absolute;
              top: 14px;
              left: 4px;
              width: 6px;
              height: 6px;
              background: #CCCCCC;
              border-radius: 50%;
            }
          }
        }
      }

      .line{
        position: absolute;
        top: 0px;
        left: 296px;
        width: 1px;
        height: 100%;
        background-color: #cccccc;

        &:before{
          content: '';
          width: 12px;
          height: 12px;
          background: #374475;
          border-radius: 6px;
          position: absolute;
          top: -6px;
          left: -6px;
        }
      }

      .rows{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .row {
          display: flex;
          flex-direction: column;
          margin-right: 43px;
          margin-bottom: 43px;

          .url-box {
            width: 311px;
            height: 345px;
            /*background: #FFF7EE;*/
            border-radius: 10px;

            .img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .title {
            height: 26px;
            font-family: 04KanjyukuGothic;
            font-weight: 400;
            font-size: 28px;
            color: #374475;
            line-height: 26px;
            margin-top: 15px;
            max-width: 311px;
            white-space: nowrap;      /* 防止文本换行 */
            overflow: hidden;         /* 隐藏超出容器的内容 */
            text-overflow: ellipsis;  /* 超出部分显示省略号 */
          }
        }
      }
    }
  }
</style>
